export default { sha: '673b1bc7fbb32dd16e00d9a79f75b042bb994761', buildNumber: 'undefined' }
